// apps/admin-ui/src/components/widgets/ContractRulesWidget.tsx
// Compact dashboard widget showing key business-rule parameters
// ALL RIGHTS RESERVED

import { getKeyParameters } from '../../config/contractRules';
import type { KeyParameter } from '../../config/contractRules';

export function ContractRulesWidget() {
  const params = getKeyParameters();

  return (
    <div className="contract-rules-widget">
      <div className="crw-grid">
        {params.map((p, i) => (
          <ParamCard key={i} param={p} />
        ))}
      </div>
      <div className="crw-footer">
        <a href="/contracts" className="crw-link">
          View all contract rules →
        </a>
      </div>
    </div>
  );
}

function ParamCard({ param }: { param: KeyParameter }) {
  return (
    <div className="crw-param">
      <div className="crw-param-value">{param.value}</div>
      <div className="crw-param-label">{param.label}</div>
      <div className="crw-param-meta">
        <span className="crw-param-contract">{param.contract}</span>
        {param.section && <span className="crw-param-section">{param.section}</span>}
      </div>
    </div>
  );
}

export default ContractRulesWidget;
